<div class="modal-header container-fluid">
  <h4 class="modal-title header-2">User Story</h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button>
</div>
<div class="modal-body container-fluid overflow-auto ">
  <div class="d-flex flex-row m-2 align-items-center">
    <span class="header-8">User Story Id:</span
    ><span class="general-text-6 id-span">{{ data.testReview?.id }}</span>
  </div>

  <div class="tab-divider-1"></div>

  <div class="d-flex flex-column m-2 mt-3">
    <span class="header-8">User Story Description:</span>
    <span class="general-text-6">{{ data.testReview?.description }}</span>
  </div>

  <div class="tab-divider"></div>

  <div class="d-flex flex-row mt-3 mb-3">
    <div
      class="container column-cover d-flex flex-column"
      *ngIf="data.testReview?.coverage"
    >
      <div class="row general-text-4" *ngIf="data.testReview?.coverage">
        <div class="col-md-8 d-flex flex-column">
          <div class="row coverage-title">
            <span class="general-text-5 t-5 d-flex flex-row align-items-center"
              >Test Scenario Coverage <mat-icon (click)="editCoverage(data?.testReview?.coverage)" (keydown.enter)="editCoverage(data?.testReview?.coverage)">edit</mat-icon></span
            >
          </div>
          <div class="d-flex flex-row gap-5">
            <div class="col-md-6 d-flex flex-column">
              <div class="d-flex flex-row">
                <span class="col-md-10">Positive Scenario:</span
                ><span class="col-md-3 header-8"
                  >{{ data.testReview?.coverage.positive_scenario }} %</span
                >
              </div>
              <div class="d-flex flex-row">
                <span class="col-md-10">Boundary Value Analysis:</span
                ><span class="col-md-3 header-8"
                  >{{
                    data.testReview?.coverage.boundary_value_analysis
                  }}
                  %</span
                >
              </div>
            </div>

            <div class="col-md-5 d-flex flex-column">
              <div class="d-flex flex-row">
                <span class="col-md-10">Negative Scenario:</span
                ><span class="col-md-3 header-8"
                  >{{ data.testReview?.coverage.negative_scenario }} %</span
                >
              </div>
              <div class="d-flex flex-row">
                <span class="col-md-10">Error Handling:</span
                ><span class="col-md-3 header-8"
                  >{{ data.testReview?.coverage.error_handling }} %</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- doughnut view -->
        <div class="col-md-4">
          <div class="doughnut-wrapper">
            <div class="doughnut">
              <div class="doughnut-text">
                {{ data.testReview?.coverage?.chart_data }} %
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container column-weight d-flex flex-column"
      *ngIf="data.testReview?.weightage"
    >
      <div class="row coverage-title">
        <span class="general-text-5 d-flex flex-row align-items-center"
          >Coverage Weightages <mat-icon (click)="editWeightage(data?.testReview?.weightage)" (keydown.enter)="editWeightage(data?.testReview?.weightage)">edit</mat-icon></span
        >
      </div>

      <div class="row general-text-4 gap-3" *ngIf="data.testReview?.weightage">
        <div class="col-md-6 d-flex flex-column">
          <div class="d-flex flex-row">
            <span class="col-md-10">Positive Scenario:</span
            ><span class="col-md-3 header-8"
              >{{ data.testReview?.weightage.positive_scenario }} %</span
            >
          </div>
          <div class="d-flex flex-row">
            <span class="col-md-10">Boundary Value Analysis:</span
            ><span class="col-md-3 header-8"
              >{{ data.testReview?.weightage.boundary_value_analysis }} %</span
            >
          </div>
        </div>
        <div class="col-md-5 d-flex flex-column">
          <div class="d-flex flex-row">
            <span class="col-md-10">Negative Scenario:</span
            ><span class="col-md-3 header-8"
              >{{ data.testReview?.weightage.negative_scenario }} %</span
            >
          </div>
          <div class="d-flex flex-row">
            <span class="col-md-10">Error Handling:</span
            ><span class="col-md-3 header-8"
              >{{ data.testReview?.weightage.error_handling }} %</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="d-flex flex-column m-2 mt-3"
    *ngIf="data?.testReview?.review_comments"
  >
    <div class="row coverage-title">
      <span class="header-8 t-5 d-flex flex-row align-items-center mb-3"
        >Review Comments
        <mat-icon (click)="reviewComments(data?.testReview?.review_comments)" (keydown.enter)="reviewComments(data?.testReview?.review_comments)"
          >edit</mat-icon
        ></span
      >
    </div>
  </div>

  <div *ngIf="data?.testReview?.review_comments">
    <div *ngFor="let item of processedKeys" class="m-2 d-flex flex-column">
      <span class="header-8">{{ transformKey(item.key) }}:</span>
      <span class="general-text-6 t">{{ item.value }}</span>
      <div class="tab-divider"></div>
    </div>
  </div>


  <div *ngIf="data?.testReview?.show_details">
    <button class="btn  btn-accello-primary" (click)="showDetails()">
      {{ isShowDetails ? "Hide Details" : "Show Details" }}
    </button>
  </div>

  <div class="d-flex m-5" *ngIf="data?.testReview?.details && isShowDetails">
    <app-table-view
      class="w-100"
      [columns]="data?.testReview?.details?.columns"
      [data]="data?.testReview?.details?.data"
    ></app-table-view>
  </div>
</div>
